// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"1":"3abb9b0d","78":"30e6faf9","491":"fbd3ac43","657":"7fc6d01b"}[chunkId] + ".css";
};